import React from "react";
import { track } from "../../utils/analytics";
import useShareLink, { shareTopicUrl, shareButtonStyle, shareButtonLabel } from "../../hooks/useShareLink";

/**
 * PublicShareButton — "⤴ Share" on the anonymous /t/<token> page.
 *
 * Anyone the admin's link reaches can pass it on without an account: the
 * token is already in the URL, so no API call is made — the button just
 * re-shares /t/<token> (opening on the step the visitor is viewing) through
 * the same share-sheet / clipboard mechanics as the admin button. If the
 * admin later revokes the link, every re-shared copy dies with it.
 */
export default function PublicShareButton({ token, step }) {
  const { shareState, share } = useShareLink();

  const onClick = () => {
    track("share-topic-reshare-click", { step });
    share(() => shareTopicUrl(token, step));
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={shareState === "busy"}
      className="shrink-0 flex items-center gap-1 px-2 py-1 text-xs rounded-md border transition-colors hover:brightness-110 disabled:opacity-60"
      style={shareButtonStyle(shareState)}
      title="Copy this link — anyone can view this topic without an account"
    >
      {shareButtonLabel(shareState)}
    </button>
  );
}
